<template>
  <div class="contacts_box">
    <p style="font-size: 16px;font-weight: bold;font-family: '苹方';margin-bottom: 12px;">{{ $t('center.Top_contacts') }}
    </p>
    <div class="add_new_con">
      <b2b-button style="width: 190px;height: 40px;line-height: 40px;"
        @click="showAddContact = true; dialogTitle = $t('center.New_contact')">{{
          $t('center.New_reservation_contact')
        }}</b2b-button>
    </div>
    <div class="con_data_box">
      <el-table :data="contactData" style="width: 100%" :empty-text="$t('center.no_data')">
        <el-table-column prop="contactName" :label="$t('booking.name')" width="180">
        </el-table-column>
        <el-table-column prop="contactEmail" :label="$t('booking.email')" width="220">
        </el-table-column>
        <el-table-column prop="contactPhone" :label="$t('booking.phone_number')" width="180">
        </el-table-column>
        <el-table-column :label="$t('center.operation')">
          <template v-slot="scoped">
            <span style="color:#1e50f0;margin-right: 10px;cursor: pointer;user-select: none;"
              @click="changeContact(scoped.row)">{{ $t('center.modify') }}</span>
            <span style="color:#1e50f0;cursor: pointer;user-select: none;" @click="delContact(scoped.row)">
              {{ $t('center.delete') }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="showAddContact" width="30%" :close-on-click-modal="false"
      @close="closeAddDialog">
      <div>
        <el-form ref="contactForm" label-position="top" :model="contactForm" style="width: 65%;" :rules="rules">
          <el-form-item :label="$t('booking.name')" prop="contactName">
            <el-input v-model="contactForm.contactName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('booking.phone_number')" prop="contactPhone">
            <el-input v-model="contactForm.contactPhone"></el-input>
          </el-form-item>
          <el-form-item :label="$t('booking.email')" prop="contactEmail">
            <el-input v-model="contactForm.contactEmail"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="showAddContact = false">{{ $t('header.cancel') }}</el-button>
            <el-button type="primary" @click="toAdd">{{ $t('header.confirm') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      contactData: [],
      showAddContact: false,
      dialogTitle: this.$t('center.New_contact'),
      contactForm: {
        contactName: '',
        contactEmail: '',
        contactPhone: ''
      },
      rules: {
        contactName: [
          { required: true, message: this.$t('register.enter_name'), trigger: 'blur' }
        ],
        contactEmail: [
          { required: true, message: this.$t('register.enter_mailbox'), trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: this.$t('center.mailbox_format'), trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: this.$t('register.enter_phone_number'), trigger: 'blur' },
          { pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/, message: this.$t('center.phone_formatter'), trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      let headerReq = {
        accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''
      }
      const { data: result } = await this.$http.get('/mini/b2bContact/get', { headers: headerReq })
      if (result.code != 200) return this.$message.error(result.message)
      this.contactData = result.data
    },
    changeContact (e) {
      this.dialogTitle = this.$t('center.Modify_contact_information')
      this.showAddContact = true
      this.contactForm = { ...e }
    },
    delContact (e) {
      let headerReq = {
        accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''
      }
      this.$confirm(this.$t('center.confirm_del'), this.$t('header.Reminder'), {
        confirmButtonText: this.$t('header.confirm'),
        cancelButtonText: this.$t('header.cancel'),
        type: 'warning'
      }).then(async () => {
        const { data: result } = await this.$http.get(`/mini/b2bContact/del?delId=${e.id}`, { headers: headerReq })
        if (result.code != 200) return this.$message.error(result.message)
        this.$message.success(this.$t('center.Delete_succeeded'))
        this.init()
      }).catch(() => {

      });
    },
    closeAddDialog () {
      this.contactForm = {
        contactName: '',
        contactEmail: '',
        contactPhone: ''
      }
    },
    toAdd () {
      this.$refs['contactForm'].validate(async (valid) => {
        if (valid) {
          let headerReq = {
            accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''
          }
          const { data: result } = await this.$http.post('/mini/b2bContact/save', this.contactForm, { headers: headerReq })
          if (result.code != 200) this.$message.error(result.message)
          this.$message.success(this.$t('center.Successfully_added'))
          this.showAddContact = false
          this.init()
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.contacts_box {
  min-height: 325px;
  padding: 20px;
  background-color: #fff;

  .add_new_con {
    display: flex;
    justify-content: right;
  }

  .con_data_box {
    margin-top: 20px;
  }

  /deep/.el-table th,
  .el-table tr {
    background-color: #f7f7f7;
    font-size: 13px;
  }

  /deep/.el-dialog__header {
    background-color: #fff;
  }

  /deep/.el-dialog__title {
    color: #303133;
  }

  /deep/.el-form--label-top .el-form-item__label {
    padding: 0;
  }

  /deep/.el-form-item__label {
    height: 30px;
    line-height: 30px;
  }

  /deep/.el-dialog__body {
    padding: 0 20px;
  }

  /deep/.el-table td,
  .el-table th {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/Contacts.vue